import { sortTypeMap } from '../../../app/app.types';

interface SortTypeCellProps {
    value: number;
  }

  export const SortTypeCell: React.FC<SortTypeCellProps> = ({  value }) => {
    return <p>{sortTypeMap[value]}</p>;
  };
